/** Convert URLs in a text string into clickable anchor tags.
 *  Splits the text on a URL regex and interleaves anchor elements.
 *  Rendering is done via React nodes so raw HTML is never dangerouslySet →
 *  the message content stays XSS-safe (React escapes text children).
 */
import React from "react";

// Matches http(s):// URLs and bare www.* URLs; stops at whitespace or common
// trailing punctuation that shouldn't be part of the URL.
const URL_RE = /((?:https?:\/\/|www\.)[^\s<>()[\]{}"']+[^\s<>()[\]{}"'.,!?;:])/gi;

export default function Linkify({ text, className }) {
  if (!text) return null;
  const parts = [];
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const raw = m[0];
    const href = raw.startsWith("http") ? raw : `https://${raw}`;
    parts.push(
      <a
        key={`${m.index}-${raw}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:opacity-80 break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {raw}
      </a>
    );
    last = m.index + raw.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <span className={className}>{parts}</span>;
}
